import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { formatMoney, formatNumber } from '../../common/helpers';
import useFetch from '../../common/useFetch';
import PrizeSchemeService from '../../domain/PrizeSchemeService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import Breadcrumbs from '../Common/Breadcrumbs';
import Loader from '../Common/Loader';
import { ConfirmationModal, useModal } from '../Common/Modal';
import FormattedPrizeMatches from './FormattedPrizeMatches';
var PrizeScheme = function (_a) {
    var history = _a.history, match = _a.match;
    var t = useTranslation()[0];
    var user = useContext(UserContext).user;
    var _b = useFetch(function (config) { return PrizeSchemeService.getPrizeScheme(match.params.prizeScheme, config); }), prizeScheme = _b.data, getPrizeScheme = _b.get;
    var deletePrizeScheme = useFetch(PrizeSchemeService.deletePrizeScheme, {
        onSuccess: function () {
            history.push('/prize-schemes');
        }
    }).post;
    var deleteModal = useModal({
        onClose: function (confirm) {
            if (confirm) {
                deletePrizeScheme(prizeScheme);
            }
        }
    });
    useEffect(function () {
        getPrizeScheme();
    }, []);
    if (!prizeScheme) {
        return React.createElement(Loader, null);
    }
    var calculation = prizeScheme.calculation;
    return React.createElement("div", null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/prize-schemes" }, t('prize_schemes'))),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, prizeScheme.title),
            React.createElement("span", { className: gs('section-options') },
                prizeScheme.editable && user.isManager() && React.createElement(Link, { to: "/prize-schemes/".concat(prizeScheme.id, "/edit"), className: gs('btn', 'btn-outline-secondary') }, t('edit')),
                ' ',
                prizeScheme.deletable && user.isManager() && React.createElement("button", { type: "button", onClick: function () { return deleteModal.open(); }, className: gs('btn', 'btn-outline-danger') }, t('delete')))),
        React.createElement("div", { className: gs('row', 'mb-4') },
            calculation && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: gs('col-md-3') },
                    React.createElement("h2", null,
                        formatNumber(calculation.win_probability * 100, { decimals: 3 }),
                        "%"),
                    t('win_probability')),
                React.createElement("div", { className: gs('col-md-3') },
                    React.createElement("h2", null, formatMoney(calculation.expected_winnings, { decimals: 3 })),
                    t('expected_winnings')))),
            React.createElement("div", { className: gs('col-md-6') },
                React.createElement("h2", null, prizeScheme.draw_mechanism.title),
                t('draw_mechanism'))),
        React.createElement("table", { className: gs('table-overview') },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '3%' } }, "#"),
                    React.createElement("th", { style: { width: '12%' } }, t('prize')),
                    React.createElement("th", { style: { width: '12%' } }, t('properties')),
                    React.createElement("th", { style: { width: '11%' } }, t('value')),
                    React.createElement("th", { style: { width: '15%' } }, t('matches')),
                    React.createElement("th", { style: { width: '14%' } }, t('distributor')),
                    React.createElement("th", { style: { width: '11%' } }, t('base_probability')),
                    React.createElement("th", { style: { width: '11%' } }, t('win_probability')),
                    React.createElement("th", { style: { width: '11%' } }, t('expected_winnings')))),
            React.createElement("tbody", null, prizeScheme.prizes.map(function (prize) {
                var _a;
                return React.createElement("tr", { key: prize.id },
                    React.createElement("td", null, prize.position),
                    React.createElement("td", null,
                        React.createElement("strong", null, prize.title)),
                    React.createElement("td", null,
                        React.createElement("code", null, prize.properties)),
                    React.createElement("td", null, formatMoney(prize.value)),
                    React.createElement("td", null,
                        !prizeScheme.draw_mechanism.guaranteed && React.createElement(FormattedPrizeMatches, { matches: prize.matches }),
                        prizeScheme.draw_mechanism.guaranteed && React.createElement("span", { className: gs('text-muted') }, t('guaranteed'))),
                    React.createElement("td", null, ((_a = prize.prize_distributor) === null || _a === void 0 ? void 0 : _a.title) || t('not_applicable_short')),
                    calculation && React.createElement(React.Fragment, null,
                        React.createElement("td", null,
                            formatNumber(calculation.prizes[prize.id].base_probability * 100, { decimals: 7, fixedDecimals: true }),
                            "%"),
                        React.createElement("td", null,
                            formatNumber(calculation.prizes[prize.id].win_probability * 100, { decimals: 7, fixedDecimals: true }),
                            "%"),
                        React.createElement("td", null, formatMoney(calculation.prizes[prize.id].expected_winnings, { decimals: 3 }))),
                    !calculation && React.createElement(React.Fragment, null,
                        React.createElement("td", { className: gs('text-muted') }, t('not_applicable_short')),
                        React.createElement("td", { className: gs('text-muted') }, t('not_applicable_short')),
                        React.createElement("td", { className: gs('text-muted') }, t('not_applicable_short'))));
            }))),
        React.createElement(ConfirmationModal, { modal: deleteModal },
            React.createElement("h5", { className: gs('my-2') }, t('confirm_delete', { title: prizeScheme.title }))));
};
export default withRouter(PrizeScheme);
